import { withProps } from 'recompose';
import { find, get } from 'lodash';

export default withProps(ownProps => ({
  // option could be updated since last user answer, that's why we are looking for latest value inside options @sinslav
  value: find(ownProps.options, { id: get(ownProps, 'input.value.id') }),
}));
